<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
	export default {
		name: 'app',
		data() {
			return{

			}
		},
		methods: {

		}
	}
</script>

<style>
  @import '../src/assets/css/reset.css';
</style>
